import React from 'react';
import { ContactUsForm } from './ContactUsForm';

const ContactUs = () => {

    return (
        <section className="w-full bg-gradient-radial py-12 lg:py-16">
            <div className="container mx-auto px-4 lg:px-12">
                {/* Heading */}
                <div className="text-center my-10">
                    <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold font-inter !text-white">
                        Get In Touch
                    </h2>
                    <p className="mt-2 text-base sm:text-lg lg:text-xl font-medium font-inter text-white/70">
                        Reach out, and let's create a universe of possibilities together!
                    </p>
                </div>

                {/* Main layout: Form + Contact info */}
                <div className="bg-[#181B23] rounded-[24px] backdrop-blur-lg border border-slate-950/10 px-4 py-8 sm:p-10 lg:p-12">
                    <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
                        {/* Left: Form */}
                        <div className="w-full lg:w-2/3 border-b lg:border-b-0 lg:border-r border-white/10 pb-8 lg:pb-0 lg:pr-10">
                            <ContactUsForm />
                        </div>

                        {/* Right: Contact info panel */}
                        <div className="w-full lg:w-1/3 flex flex-col justify-between gap-8 lg:gap-10">
                            <div className="w-full">
                                <img className="w-32 sm:w-40 lg:w-44 h-auto" src="/assets/FWPI-logo.png" alt="FWPI Logo" />
                                <p className="text-white text-sm leading-tight mt-2 md:mt-8">
                                    Every credible wellness journey begins with FWPI
                                </p>
                            </div>

                            <div className="space-y-5 text-white/80 text-sm sm:text-base">
                                {/* Phone */}
                                <div className="flex items-start gap-3">
                                    <span className="mt-1 inline-flex h-8 w-8 p-2.5 items-center justify-center rounded-full bg-white/10">
                                        {/* phone icon */}
                                        <img className="w-full h-full -rotate-90 transition-transform" src="/assets/gym-facilities/call.png" alt="phone" />
                                    </span>
                                    <div className='flex flex-1 flex-col items-start font-inter'>
                                        <p className="text-xs uppercase tracking-wide text-white/60">
                                            Phone
                                        </p>
                                        <a href={`tel:9996108446`} className="text-white hover:!text-gray-400 mt-0.5">+91 9996108446</a>
                                    </div>
                                </div>

                                {/* Email */}
                                <div className="flex items-start gap-3">
                                    <span className="mt-1 inline-flex h-8 w-8 p-2.5 items-center justify-center rounded-full bg-white/10">
                                        {/* mail icon */}
                                        <img className="w-full h-full transition-transform" src="/assets/gym-facilities/email.png" alt="email" />
                                    </span>
                                    <div className='flex flex-1 flex-col items-start font-inter'>
                                        <p className="text-xs uppercase tracking-wide text-white/60">
                                            Email
                                        </p>
                                        <a href={`mailto:support@fwpiindia.com`} className="text-white hover:!text-gray-400 mt-0.5">support@fwpiindia.com</a>
                                    </div>
                                </div>

                               
                            </div>

                            {/* Social icons */}
                            <div className="flex items-center gap-4">
                                <a target='_blank' rel="noreferrer" href="https://www.instagram.com/fwpi_india?igsh=N2Nyd2JydGh6b3Np" className="group w-9 h-9 p-2.5 rounded-full bg-white/5 flex items-center justify-center hover:scale-105">
                                    <img className='group-hover:scale-105' src='/assets/footers/instagram.png' alt='instagram' />
                                </a>
                                <a target='_blank' rel="noreferrer" href="https://www.linkedin.com/company/fitness-wellness-professionals-of-india/" className="group w-9 h-9 p-2.5 rounded-full bg-white/5 flex items-center justify-center hover:scale-105">
                                    <svg className='group-hover:scale-105' stroke="#ffffff" fill="#ffffff" strokeWidth="0" viewBox="0 0 1024 1024" height="200px" width="200px" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.3-434a68.8 68.8 0 1 1 68.8-68.8c-.1 38-30.9 68.8-68.8 68.8zm503.7 434H675.1V608c0-44.3-.8-101.2-61.7-101.2-61.7 0-71.2 48.2-71.2 98v188.9H423.7V411.9h113.8v52.2h1.6c15.8-30 54.5-61.7 112.3-61.7 120.2 0 142.3 79.1 142.3 181.9v209.4z"></path>
                                    </svg>
                                </a>
                                <a target='_blank' rel="noreferrer" href="https://www.facebook.com/share/17Ak3eeGv2/" className="group w-9 h-9 p-2.5 rounded-full bg-white/5 flex items-center justify-center hover:scale-105">
                                    <img className='group-hover:scale-105' src='/assets/footers/facebook.png' alt='facebook' />
                                </a>
                                <a target='_blank' rel="noreferrer" href="https://youtube.com/@fwpi_india?si=6uTt_Uapy2bV7lnd" className="group w-9 h-9 p-2.5 rounded-full bg-white/5 flex items-center justify-center hover:scale-105">
                                    <svg className='group-hover:scale-105' stroke="#ffffff" fill="#ffffff" strokeWidth="0" viewBox="0 0 1024 1024" height="200px" width="200px" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M941.3 296.1a112.3 112.3 0 0 0-79.2-79.3C792.2 198 512 198 512 198s-280.2 0-350.1 18.7A112.12 112.12 0 0 0 82.7 296C64 366 64 512 64 512s0 146 18.7 215.9c10.3 38.6 40.7 69 79.2 79.3C231.8 826 512 826 512 826s280.2 0 350.1-18.8c38.6-10.3 68.9-40.7 79.2-79.3C960 658 960 512 960 512s0-146-18.7-215.9zM423 646V378l232 133-232 135z"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </section >
    );
};

export { ContactUs };
